export const GeneralSearchLayoutEnum = Object.freeze({
  Default: "",
  Mindegave: "Mindegave Visning"
});

export function GetLayoutStyle(layoutStyle) {
  if (layoutStyle == null || String(layoutStyle).trim() === "") {
    return GeneralSearchLayoutEnum.Default;
  }

  const input = String(layoutStyle).trim();
  const match = Object.values(GeneralSearchLayoutEnum).find(
    (v) => v.toLowerCase() === input.toLowerCase()
  );

  return match ?? GeneralSearchLayoutEnum.Default;
}